import React, { FunctionComponent } from "react"
import { FormControl, Table } from "react-bootstrap"
import EALAService from "../../Utils/EALAService"
import addEalaBoiler from "../../Utils/BoilerPlates/addEalaBoiler"
import NormalizedReferenceDataTypes from "../../Types/NormalizedReferenceDataTypes"
import "./AddEALAList.css"
import AddEALASuggestPromotion from "../AddEALASuggestPromotion/AddEALASuggestPromotion"

interface AddEALAListProps {
    manageParentState: Function
    AccessLevelID: number
    areas: NormalizedReferenceDataTypes
}

const AddEALAList: FunctionComponent<AddEALAListProps> = (props) => {

    const { manageParentState, AccessLevelID, areas } = props
    const { tableItems, lookupHashTableItem, updateHashTableItem, getTableIdentifierByAccessLevelID } = EALAService
    const tableIdentifier = getTableIdentifierByAccessLevelID(AccessLevelID)

    //console.log("AddEALAList props", props)
    //console.log("AddEALAList areas", areas)





    return (
        <div className="AddEALAList">
            <Table id="add-eala-list">
                <tbody>
                    {areas.map((area, i) => {
                        let bucketItem = lookupHashTableItem(tableIdentifier, area.id)
                        const add = bucketItem[6].add
                        // console.log(`AddEALAList bucketItem-${i}`, bucketItem)
                        return (
                            <tr key={i}>
                                <td>
                                    <div className="AddEALAListAreaFirstTDItem"
                                        onClick={() => {
                                            bucketItem[6].add = !add
                                            bucketItem[7] = { ...addEalaBoiler }
                                            if (AccessLevelID === 50) {
                                                bucketItem[7].CanViewTime = false
                                            }
                                            updateHashTableItem(tableIdentifier, bucketItem)
                                            manageParentState([])
                                        }}
                                    >
                                        <div className="AddEALAListAreaFirstTDItemCheckbox">
                                            <FormControl
                                                checked={add}
                                                onChange={() => null}
                                                type="checkbox"
                                            />
                                        </div>
                                        <div className="AddEALAListAreaFirstTDItemTitle">
                                            <p>{area.text}</p>
                                        </div>
                                    </div>
                                </td>
                                {tableItems.slice(1).map((tdItem, j) => {
                                    const hasPermission = bucketItem ? bucketItem[7][tableItems[j + 1].key] : false
                                    return (
                                        <td style={{ width: tdItem.width ? tdItem.width : "unset" }} key={j}>
                                            <div className={`AddEALAListAreaControls AddEALAListAreaControls${add ? "NotFaded" : "Faded"}`}
                                                onClick={() => {
                                                    if (add) {
                                                        bucketItem[7][tableItems[j + 1].key] = !hasPermission
                                                        updateHashTableItem(tableIdentifier, bucketItem)
                                                        manageParentState([])
                                                    } else {
                                                        bucketItem[6].add = !add
                                                        bucketItem[7] = { ...addEalaBoiler }
                                                        updateHashTableItem(tableIdentifier, bucketItem)
                                                        manageParentState([])
                                                    }
                                                }}
                                            >
                                                <FormControl
                                                    checked={add && hasPermission}
                                                    disabled={!add}
                                                    onChange={() => null}
                                                    type="checkbox"
                                                />
                                                <p>{tdItem.title}</p>
                                            </div>
                                        </td>
                                    )
                                }
                                )}
                            </tr>
                        )
                    }
                    )}
                </tbody>
            </Table>
        </div>
    )
}

export default AddEALAList